import axios from 'axios'
const url = "https://www.lefisc.com.br/api/arqlef"
const token = "5f900aa22283470900174caed0f8a148"
export default{     
    statusNfe(idEmpresa,chaveAcesso){        
        return axios
        .get(`${url}/nfe/consultaProtocolo/${idEmpresa}/${chaveAcesso}`)
        .then(res => {
            return res;
        })
        .catch(error => error.response);
    },
    uploadNfe(idEmpresa,file){        
        return axios
        .post(`${url}/nfe/uploadXML/${idEmpresa}/${token}`,file)
        .then(res => {
            return res;
        })
        .catch(error => error.response);
    },
    uploadNfce(lista){
        return axios
        .post(`${url}/nfce/upload/`,lista)
        .then(res => {
            return res;
        })
        .catch(error => error.response);
    },
    getNotasNfce(lista){
        return axios
        .post(`${url}/nfce/buscar/${token}`,lista)
        .then(res => {
            return res;
        })
        .catch(error => error.response);
    },
    getRelatorio(id,tipo,post){
        return axios
        .post(`${url}/relatorio/exportar/${id}/${tipo}`,post)
        .then(res => {
            return res;
        })
        .catch(error => error.response);
    },
   getNotasCte(lista){    
        return axios
        .post(`${url}/cte/buscarDocumentos/${token}`,lista)
        .then(res => {
            return res;
        })
        .catch(error => error.response);
   },
    getTexto(){
        return axios
        .get(`${url}/nfe/buscarTexto/${token}`)
        .then(res => {
            return res;
        })
        .catch(error => error.response);
    } ,
    dowloandZip(idEmpresa,lista,tipo){
        if(tipo == 'NFe'){
            return axios
            .post(`${url}/nfe/downloadZIP/${idEmpresa}/${token}`,lista)
            .then(res => {
                return res;
            })
            .catch(error => error.response);
        }else{
            return axios
            .post(`${url}/cte/exportarDocumentos/${idEmpresa}/${token}`,lista)
            .then(res => {
                return res;
            })
            .catch(error => error.response);
        }
    }, 
    excluirEmpresa(idEmpresa,idCliente){
        return axios
        .get(`${url}/empresa/deletar/${idEmpresa}/${idCliente}`)
        .then(res => {
            return res;
        })
        .catch(error => error.response);
    },
    verificarStatus(idEmpresa){
        return axios
        .get(`${url}/nfe/verificarStatus/${idEmpresa}/${token}`)
        .then(res => {
            return res;
        })
        .catch(error => error.response);
    },
    manifestar(idEmpresa,lista){
        return axios
        .post(`${url}/nfe/manifestarNFe/${idEmpresa}/${token}`,lista)
        .then(res => {
            return res;
        })
        .catch(error => error.response);
    },
    consultarEstado(){
        return axios
        .get(`${url}/nfe/consultarEstado/${token}`)
        .then(res => {
            return res.data;
        })
        .catch(err => console.log(err));
    },
    empresasCliente(idCliente){
        return axios
        .get(`${url}/empresa/buscar/${idCliente}/${token}`)
        .then(res => {
            return res;
        })
        .catch(error => error.response);
    },
    cadastrarEmpresa(empresa){
        return axios
        .post(`${url}/empresa/cadastrar/${token}`,empresa)
        .then(res => {
            return res;
        })
        .catch(error => error.response);
    },
    getNotasRecebidas(idEmpresa,quant){
        return axios
        .get(`${url}/nfe/buscarNotas/${idEmpresa}/${quant}/${token}`)
        .then(res => {
            return res.data;
        })
        .catch(error => error.response.data);
    },   
    getNfeCompleta(idEmpresa,chaveAcesso){  
        return axios
        .get(`${url}/nfe/visualizarNotaCompleta/${idEmpresa}/${chaveAcesso}`)
        .then(res => {
            return res;
        })
        .catch(error => error.response);     
    },
    getNotasV2(lista){
        return axios
        .post(`${url}/nfe/buscarNotasV2/${token}`,lista)
        .then(res => {
            return res;
        })
        .catch(error => error.response);
    },
    cadastrarCertificado(idEmpresa,certifi){
        return axios
        .post(`${url}/nfe/uploadCertificado/${idEmpresa}/${token}`,certifi)
        .then(res => {
            return res;
        })
        .catch(error => error.response);
    },
    deletarCertificado(idEmpresa){
        return axios
        .get(`${url}/nfe/deletarCertificado/${idEmpresa}/${token}`)
        .then(res => {
            return res.data;
        })
        .catch(error => error.response.data);
    },
   
    consultaDocumento(idEmpresa, tipo){
        if(tipo == 'NFe'){
            return axios
            .get(`${url}/nfe/consultaDocumento/${idEmpresa}/${token}`)
            .then(res => {
                return res;
            })
            .catch(error => error.response);
        }else{
            return axios
            .get(`${url}/cte/consultaDocumento/${idEmpresa}/${token}`)
            .then(res => {
                return res;
            })
            .catch(error => error.response);
        }
    },
    danfe(idEmpresa,chaveAcesso){
        return axios
        .get(`${url}/nfe/downloadDANFE/${idEmpresa}/${chaveAcesso}/${token}`)
        .then(res => {
            return res.data;
        })
        .catch(error => error.response);
    }
}